module.exports = __webpack_public_path__ + "static/media/forkodes.bb9b552b.png";